  

Shopify.Cart = Shopify.Cart || {};

  Shopify.Cart.GiftWrap = {};

// When the gift-wrapping checkbox is checked or unchecked.
function processGiftWrapping() {    
    const el = document.getElementById('gift-wrapping');
    if (el) {
        if (el.checked) {
            Shopify.Cart.GiftWrap.set();
        } else {
            Shopify.Cart.GiftWrap.remove();
        }
    }
}

// When the gift wrapping notes are changed
function processGiftWrappingNotes() {   
    const el = document.getElementById('gift-note');
    if (el) {
        var note = el.value;
        var headers = new Headers({ 'Content-Type': 'application/json' });

        var request = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ attributes: { 'gift-note': note } })
        };

        fetch('/cart/update.js', request);
    }
}
